import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import ServiceCard from "components/_strategy/ServiceCard"

const HomeStrategy = () => {
  const data = useStaticQuery(graphql`
    query {
      wpContentSettings(id: { eq: "cG9zdDoyMQ==" }) {
        home {
          strategyContent
          strategyCtaLink {
            ... on WpPage {
              slug
            }
          }
          strategyCtaText
          strategyIntroTitle
          strategyStepOneContent
          strategyStepOneTitle
          strategyStepTwoContent
          strategyStepTwoTitle
          strategyStepThreeContent
          strategyStepThreeTitle
          strategyTitle
          strategyTopTitle
        }
      }
    }
  `)

  const {
    strategyTopTitle,
    strategyIntroTitle,
    strategyTitle,
    strategyContent,
    strategyCtaText,
    strategyCtaLink,
    strategyStepOneContent,
    strategyStepOneTitle,
    strategyStepTwoContent,
    strategyStepTwoTitle,
    strategyStepThreeContent,
    strategyStepThreeTitle,
  } = data.wpContentSettings.home

  return (
    <>
      <div className="row text-center">
        <div className="col-lg-10 col-xl-10 col-xxl-8 mx-auto">
          <h2 className="fs-17 text-uppercase text-muted mb-3">
            {strategyTopTitle}
          </h2>
          <h3 className="display-4 mb-9">{strategyTitle}</h3>
        </div>
      </div>
      <div className="row gx-md-8 gx-xl-12 gy-10 align-items-center">
        <div className="col-lg-6">
          <h3 className="display-4 mb-5">{strategyIntroTitle}</h3>
          <p>{strategyContent}</p>

          <Link
            to={strategyCtaLink.slug}
            className="btn btn-primary rounded-pill mb-0"
          >
            {strategyCtaText}
          </Link>
        </div>

        <div className="col-lg-6">
          <div>
            <ServiceCard
              key="1"
              title={strategyStepOneTitle}
              description={strategyStepOneContent}
              className="d-flex flex-row my-6"
              Icon={
                <span
                  className={`icon btn btn-block btn-lg btn-soft-orange pe-none mt-1 me-5`}
                >
                  <span className="number fs-22">1</span>
                </span>
              }
            />
          </div>

          <ServiceCard
            key="2"
            title={strategyStepTwoTitle}
            description={strategyStepTwoContent}
            className="d-flex flex-row my-6"
            Icon={
              <span
                className={`icon btn btn-block btn-lg btn-soft-orange pe-none mt-1 me-5`}
              >
                <span className="number fs-22">2</span>
              </span>
            }
          />
          <ServiceCard
            key="3"
            title={strategyStepThreeTitle}
            description={strategyStepThreeContent}
            className="d-flex flex-row my-6"
            Icon={
              <span
                className={`icon btn btn-block btn-lg btn-soft-orange pe-none mt-1 me-5`}
              >
                <span className="number fs-22">3</span>
              </span>
            }
          />
        </div>
      </div>
    </>
  )
}

export default HomeStrategy
